module.exports = __webpack_public_path__ + "img/body-3-lg.9d38d96a.png";